/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { Society } from 'types';
import { hasUnlimitedVersion } from 'utils/hasUnlimitedVersion';
import { percentFormatDecimals } from 'constants/formats';

type PartnerSocietyPercentageProps = {
  decimalScale: number;
  NDpercent: number;
  FDpercent: number;
  PFDPercent: number;
  isAdmin: boolean;
  society: Society;
};

const PartnerSocietyPercentage: FC<PartnerSocietyPercentageProps> = ({
  decimalScale,
  NDpercent,
  FDpercent,
  PFDPercent,
  isAdmin,
  society,
}) => {
  const { t } = useTranslate();

  const formatPercent = (percent: number) => (
    <NumberFormat
      value={percent || 0}
      displayType="text"
      {...percentFormatDecimals}
      decimalScale={decimalScale}
    />
  );

  return (
    <div className="nk-fmg-status">
      <h6 className="nk-fmg-status-title">
        <em className="icon ni ni-meter" />
        <span>
          {t('Percentage')}:&nbsp;
          {formatPercent(NDpercent)}
        </span>
      </h6>

      <div className="progress progress-md bg-light">
        <div
          className="progress-bar"
          data-progress={NDpercent || 0}
          style={{
            width: `${NDpercent > 0 ? +NDpercent : 0}%`,
          }}
        />
      </div>

      <div className="nk-fmg-status-info">
        {formatPercent(NDpercent)} {t('ND')} |&nbsp;
        {formatPercent(FDpercent)} {t('FD')} |&nbsp;
        {formatPercent(PFDPercent)} {t('PotentialFD')}
      </div>

      {hasUnlimitedVersion() && (
        <>
          {isAdmin && (
            <div className="nk-fmg-status-action">
              <Link
                to={`/socios-libro/${society['_id']}`}
                className="link link-primary link-sm"
              >
                {t('SeeBookOfPartners')}
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PartnerSocietyPercentage;
